import { Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { registrationFormService } from "../../shared/api/registrationForms";
import { useRegistrationForm } from "../provider/registrationFormProviderContext";
import { CancellationShopSummary } from "./shopSummary/CancellationShopSummary";
import { StaticStepForm } from "./StaticStepForm";

export const RegistrationCancelPage = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const {
		registrationForm: { id, guest, isCancelable, isShopEnabled },
		cancelRegistration,
	} = useRegistrationForm();
	const { data, isLoading } = useQuery({
		queryKey: registrationFormService.keys.showConfirmCancellation(id),
		queryFn: () => registrationFormService.showConfirmCancellation(id).then((x) => x.data.data),
	});

	const { data: cancellationSummaryResource, isLoading: isShopLoading } = useQuery({
		enabled: isShopEnabled,
		queryKey: registrationFormService.keys.cancellationSummary(id, guest.id),
		queryFn: () => registrationFormService.getCancellationSummary(id, guest.id).then((x) => x.data.data),
	});

	if (!isCancelable) {
		navigate("../landing-page");
	}

	if (isLoading || !data || (isShopEnabled && (isShopLoading || !cancellationSummaryResource))) {
		return <Loading />;
	}

	return (
		<StaticStepForm
			step={data.step}
			handleSubmit={cancelRegistration}
			guestAttributeValues={guest.guestAttributeValues}
			submitButtonTitle={isShopEnabled ? t("Accept cancellation conditions") : t("registration.submit")}
		>
			{isShopEnabled && !!cancellationSummaryResource?.transactionItemsToBeRefunded.length && (
				<CancellationShopSummary cancellationSummaryResource={cancellationSummaryResource} />
			)}
		</StaticStepForm>
	);
};
